'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; // Lib


// Constants


var _reactRedux = require('react-redux');

var _editorConstants = require('../editorConstants');

exports.default = function () {
    var opts = _extends({}, arguments.length <= 3 ? undefined : arguments[3], {
        storeKey: _editorConstants.EDITOR_STORE_NAME,
        getDisplayName: function getDisplayName(component) {
            return 'EditorStoreConnect(' + component + ')';
        }
    });
    return (0, _reactRedux.connect)(arguments.length <= 0 ? undefined : arguments[0], arguments.length <= 1 ? undefined : arguments[1], arguments.length <= 2 ? undefined : arguments[2], opts);
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/editor/store/components/editorStoreConnect.js
// module id = 689
// module chunks = 0